import type { Theme } from './types/theme'

export const solarizedTheme: Theme = Object.freeze({
  comment: '#93a1a1',
  error: '#f44747',

  literal: '#956900',
  string: '#2aa198',
  number: '#d33682',

  operator: '#857900',
  keyword: '#333333',
  variable: '#268bd2',
})
